/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  Attempt,
  BankDisconnected,
  DriverPaymentsReport,
  GetApiPaymentsReturnParams,
  GetApiSettingsQrPaymentTbCallbackParams,
  GetInvoicesSepaBatchPreviewParams,
  GetPaymentsByDriverParams,
  GetPaymentsCountParams,
  GetPaymentsParams,
  GetPaymentsReturnParams,
  GetPaymentsUnreconciledParams,
  GetRevenueHandoversParams,
  GetSettingsQrPaymentTbCallbackParams,
  InitiatePaymentRequest,
  Initiated,
  OnlinePayment,
  PaymentCallbackAcknowledged,
  PaymentConnectionTest,
  PaymentCounts,
  PaymentRefunded,
  PaymentSchedulerRun,
  PaymentSettings,
  PaymentSettingsRequest,
  Plan,
  PostApiPaymentsCallbackBody,
  PostInvoicesInvoiceIdWithdrawFromBatch200,
  PostPaymentsCallbackBody,
  PublicPaymentSettings,
  QrPaymentAvailability,
  QrPaymentConfirmRequest,
  QrPaymentConfirmed,
  QrPaymentData,
  QrPaymentSettings,
  QrPaymentSettingsRequest,
  QrPaymentStatus,
  RevenueHandoverHandledBatch,
  RevenueHandoverHandledBatchRequest,
  RevenueHandoverHandledRequest,
  RevenueHandoverRequest,
  Row,
  ScheduleAutoPayRequest,
  SepaBatchRequest,
  Swept,
  TatraBankaConnect,
  TatraBankaConsentCallback,
  TatrabankaSettingsRequest,
  UnreconciledCardOrders,
  Visible,
  WithdrawRequest,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getGetPaymentsGpwebpayReturnUrl = () => {
  return `/api/v1/payments/gpwebpay/return`
}

/**
 * @summary The customer's return from GP webpay
 */
export const getPaymentsGpwebpayReturn = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getGetPaymentsGpwebpayReturnUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetPaymentsGpwebpayReturnQueryKey = () => {
  return [`/api/v1/payments/gpwebpay/return`] as const
}

export const getGetPaymentsGpwebpayReturnQueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentsGpwebpayReturn>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getPaymentsGpwebpayReturn>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPaymentsGpwebpayReturnQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentsGpwebpayReturn>>> = ({
    signal,
  }) => getPaymentsGpwebpayReturn({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPaymentsGpwebpayReturn>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentsGpwebpayReturnQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentsGpwebpayReturn>>
>
export type GetPaymentsGpwebpayReturnQueryError = unknown

export function useGetPaymentsGpwebpayReturn<
  TData = Awaited<ReturnType<typeof getPaymentsGpwebpayReturn>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsGpwebpayReturn>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsGpwebpayReturn>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsGpwebpayReturn>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsGpwebpayReturn<
  TData = Awaited<ReturnType<typeof getPaymentsGpwebpayReturn>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsGpwebpayReturn>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsGpwebpayReturn>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsGpwebpayReturn>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsGpwebpayReturn<
  TData = Awaited<ReturnType<typeof getPaymentsGpwebpayReturn>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsGpwebpayReturn>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The customer's return from GP webpay
 */

export function useGetPaymentsGpwebpayReturn<
  TData = Awaited<ReturnType<typeof getPaymentsGpwebpayReturn>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsGpwebpayReturn>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPaymentsGpwebpayReturnQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostPaymentsGpwebpayReturnUrl = () => {
  return `/api/v1/payments/gpwebpay/return`
}

/**
 * @summary The customer's return from GP webpay
 */
export const postPaymentsGpwebpayReturn = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getPostPaymentsGpwebpayReturnUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostPaymentsGpwebpayReturnMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPaymentsGpwebpayReturn>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPaymentsGpwebpayReturn>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postPaymentsGpwebpayReturn']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPaymentsGpwebpayReturn>>,
    void
  > = () => {
    return postPaymentsGpwebpayReturn(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostPaymentsGpwebpayReturnMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPaymentsGpwebpayReturn>>
>

export type PostPaymentsGpwebpayReturnMutationError = unknown

/**
 * @summary The customer's return from GP webpay
 */
export const usePostPaymentsGpwebpayReturn = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postPaymentsGpwebpayReturn>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postPaymentsGpwebpayReturn>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostPaymentsGpwebpayReturnMutationOptions(options), queryClient)
}
export const getGetSettingsPaymentsUrl = () => {
  return `/api/v1/settings/payments`
}

/**
 * @summary The gateway's configuration, with the secret masked
 */
export const getSettingsPayments = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<PaymentSettings> => {
  return customFetch<PaymentSettings>(getGetSettingsPaymentsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsPaymentsQueryKey = () => {
  return [`/api/v1/settings/payments`] as const
}

export const getGetSettingsPaymentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsPayments>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsPayments>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsPaymentsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsPayments>>> = ({ signal }) =>
    getSettingsPayments({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsPayments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsPaymentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsPayments>>
>
export type GetSettingsPaymentsQueryError = unknown

export function useGetSettingsPayments<
  TData = Awaited<ReturnType<typeof getSettingsPayments>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPayments>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsPayments>>,
          TError,
          Awaited<ReturnType<typeof getSettingsPayments>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsPayments<
  TData = Awaited<ReturnType<typeof getSettingsPayments>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPayments>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsPayments>>,
          TError,
          Awaited<ReturnType<typeof getSettingsPayments>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsPayments<
  TData = Awaited<ReturnType<typeof getSettingsPayments>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsPayments>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The gateway's configuration, with the secret masked
 */

export function useGetSettingsPayments<
  TData = Awaited<ReturnType<typeof getSettingsPayments>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsPayments>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsPaymentsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPutSettingsPaymentsUrl = () => {
  return `/api/v1/settings/payments`
}

/**
 * @summary Change the gateway's configuration
 */
export const putSettingsPayments = async (
  paymentSettingsRequest: PaymentSettingsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaymentSettings> => {
  return customFetch<PaymentSettings>(getPutSettingsPaymentsUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(paymentSettingsRequest),
  })
}

export const getPutSettingsPaymentsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsPayments>>,
    TError,
    { data: PaymentSettingsRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsPayments>>,
  TError,
  { data: PaymentSettingsRequest },
  TContext
> => {
  const mutationKey = ['putSettingsPayments']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsPayments>>,
    { data: PaymentSettingsRequest }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsPayments(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsPaymentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsPayments>>
>
export type PutSettingsPaymentsMutationBody = PaymentSettingsRequest
export type PutSettingsPaymentsMutationError = unknown

/**
 * @summary Change the gateway's configuration
 */
export const usePutSettingsPayments = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsPayments>>,
      TError,
      { data: PaymentSettingsRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsPayments>>,
  TError,
  { data: PaymentSettingsRequest },
  TContext
> => {
  return useMutation(getPutSettingsPaymentsMutationOptions(options), queryClient)
}
export const getPutRevenueHandoversHandoverIdHandledUrl = (handoverId: number) => {
  return `/api/v1/revenue-handovers/${handoverId}/handled`
}

/**
 * @summary Mark a handover as handled - the cash was received
 */
export const putRevenueHandoversHandoverIdHandled = async (
  handoverId: number,
  revenueHandoverHandledRequest?: RevenueHandoverHandledRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<Row> => {
  return customFetch<Row>(getPutRevenueHandoversHandoverIdHandledUrl(handoverId), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(revenueHandoverHandledRequest),
  })
}

export const getPutRevenueHandoversHandoverIdHandledMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putRevenueHandoversHandoverIdHandled>>,
    TError,
    { handoverId: number; data?: RevenueHandoverHandledRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putRevenueHandoversHandoverIdHandled>>,
  TError,
  { handoverId: number; data?: RevenueHandoverHandledRequest },
  TContext
> => {
  const mutationKey = ['putRevenueHandoversHandoverIdHandled']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putRevenueHandoversHandoverIdHandled>>,
    { handoverId: number; data?: RevenueHandoverHandledRequest }
  > = (props) => {
    const { handoverId, data } = props ?? {}

    return putRevenueHandoversHandoverIdHandled(handoverId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutRevenueHandoversHandoverIdHandledMutationResult = NonNullable<
  Awaited<ReturnType<typeof putRevenueHandoversHandoverIdHandled>>
>
export type PutRevenueHandoversHandoverIdHandledMutationBody =
  RevenueHandoverHandledRequest | undefined
export type PutRevenueHandoversHandoverIdHandledMutationError = unknown

/**
 * @summary Mark a handover as handled - the cash was received
 */
export const usePutRevenueHandoversHandoverIdHandled = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putRevenueHandoversHandoverIdHandled>>,
      TError,
      { handoverId: number; data?: RevenueHandoverHandledRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putRevenueHandoversHandoverIdHandled>>,
  TError,
  { handoverId: number; data?: RevenueHandoverHandledRequest },
  TContext
> => {
  return useMutation(getPutRevenueHandoversHandoverIdHandledMutationOptions(options), queryClient)
}
export const getDeleteRevenueHandoversHandoverIdHandledUrl = (handoverId: number) => {
  return `/api/v1/revenue-handovers/${handoverId}/handled`
}

/**
 * @summary Unmark a handover - nobody has received it after all
 */
export const deleteRevenueHandoversHandoverIdHandled = async (
  handoverId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<Row> => {
  return customFetch<Row>(getDeleteRevenueHandoversHandoverIdHandledUrl(handoverId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteRevenueHandoversHandoverIdHandledMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRevenueHandoversHandoverIdHandled>>,
    TError,
    { handoverId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRevenueHandoversHandoverIdHandled>>,
  TError,
  { handoverId: number },
  TContext
> => {
  const mutationKey = ['deleteRevenueHandoversHandoverIdHandled']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRevenueHandoversHandoverIdHandled>>,
    { handoverId: number }
  > = (props) => {
    const { handoverId } = props ?? {}

    return deleteRevenueHandoversHandoverIdHandled(handoverId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteRevenueHandoversHandoverIdHandledMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRevenueHandoversHandoverIdHandled>>
>

export type DeleteRevenueHandoversHandoverIdHandledMutationError = unknown

/**
 * @summary Unmark a handover - nobody has received it after all
 */
export const useDeleteRevenueHandoversHandoverIdHandled = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteRevenueHandoversHandoverIdHandled>>,
      TError,
      { handoverId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteRevenueHandoversHandoverIdHandled>>,
  TError,
  { handoverId: number },
  TContext
> => {
  return useMutation(
    getDeleteRevenueHandoversHandoverIdHandledMutationOptions(options),
    queryClient,
  )
}
export const getPostTatrabankaRunSchedulerUrl = () => {
  return `/api/v1/tatrabanka/run-scheduler`
}

/**
 * @summary Attempt every invoice that has come due
 */
export const postTatrabankaRunScheduler = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<PaymentSchedulerRun> => {
  return customFetch<PaymentSchedulerRun>(getPostTatrabankaRunSchedulerUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostTatrabankaRunSchedulerMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTatrabankaRunScheduler>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTatrabankaRunScheduler>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postTatrabankaRunScheduler']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTatrabankaRunScheduler>>,
    void
  > = () => {
    return postTatrabankaRunScheduler(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostTatrabankaRunSchedulerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTatrabankaRunScheduler>>
>

export type PostTatrabankaRunSchedulerMutationError = unknown

/**
 * @summary Attempt every invoice that has come due
 */
export const usePostTatrabankaRunScheduler = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTatrabankaRunScheduler>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postTatrabankaRunScheduler>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostTatrabankaRunSchedulerMutationOptions(options), queryClient)
}
export const getPostSettingsQrPaymentTbDisconnectUrl = () => {
  return `/api/v1/settings/qr-payment/tb-disconnect`
}

/**
 * @summary Forget the bank connection
 */
export const postSettingsQrPaymentTbDisconnect = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<BankDisconnected> => {
  return customFetch<BankDisconnected>(getPostSettingsQrPaymentTbDisconnectUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostSettingsQrPaymentTbDisconnectMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSettingsQrPaymentTbDisconnect>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSettingsQrPaymentTbDisconnect>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postSettingsQrPaymentTbDisconnect']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSettingsQrPaymentTbDisconnect>>,
    void
  > = () => {
    return postSettingsQrPaymentTbDisconnect(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSettingsQrPaymentTbDisconnectMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSettingsQrPaymentTbDisconnect>>
>

export type PostSettingsQrPaymentTbDisconnectMutationError = unknown

/**
 * @summary Forget the bank connection
 */
export const usePostSettingsQrPaymentTbDisconnect = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSettingsQrPaymentTbDisconnect>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSettingsQrPaymentTbDisconnect>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostSettingsQrPaymentTbDisconnectMutationOptions(options), queryClient)
}
export const getGetRevenueHandoversUrl = (params?: GetRevenueHandoversParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/revenue-handovers?${stringifiedParams}`
    : `/api/v1/revenue-handovers`
}

/**
 * @summary The handovers, newest first
 */
export const getRevenueHandovers = async (
  params?: GetRevenueHandoversParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Row[]> => {
  return customFetch<Row[]>(getGetRevenueHandoversUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetRevenueHandoversQueryKey = (params?: GetRevenueHandoversParams) => {
  return [`/api/v1/revenue-handovers`, ...(params ? [params] : [])] as const
}

export const getGetRevenueHandoversQueryOptions = <
  TData = Awaited<ReturnType<typeof getRevenueHandovers>>,
  TError = unknown,
>(
  params?: GetRevenueHandoversParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRevenueHandovers>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetRevenueHandoversQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRevenueHandovers>>> = ({ signal }) =>
    getRevenueHandovers(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRevenueHandovers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRevenueHandoversQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRevenueHandovers>>
>
export type GetRevenueHandoversQueryError = unknown

export function useGetRevenueHandovers<
  TData = Awaited<ReturnType<typeof getRevenueHandovers>>,
  TError = unknown,
>(
  params: undefined | GetRevenueHandoversParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRevenueHandovers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRevenueHandovers>>,
          TError,
          Awaited<ReturnType<typeof getRevenueHandovers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRevenueHandovers<
  TData = Awaited<ReturnType<typeof getRevenueHandovers>>,
  TError = unknown,
>(
  params?: GetRevenueHandoversParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRevenueHandovers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRevenueHandovers>>,
          TError,
          Awaited<ReturnType<typeof getRevenueHandovers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRevenueHandovers<
  TData = Awaited<ReturnType<typeof getRevenueHandovers>>,
  TError = unknown,
>(
  params?: GetRevenueHandoversParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRevenueHandovers>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The handovers, newest first
 */

export function useGetRevenueHandovers<
  TData = Awaited<ReturnType<typeof getRevenueHandovers>>,
  TError = unknown,
>(
  params?: GetRevenueHandoversParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRevenueHandovers>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRevenueHandoversQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostRevenueHandoversUrl = () => {
  return `/api/v1/revenue-handovers`
}

/**
 * @summary Record a shift's cash handover
 */
export const postRevenueHandovers = async (
  revenueHandoverRequest: RevenueHandoverRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<Row> => {
  return customFetch<Row>(getPostRevenueHandoversUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(revenueHandoverRequest),
  })
}

export const getPostRevenueHandoversMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postRevenueHandovers>>,
    TError,
    { data: RevenueHandoverRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postRevenueHandovers>>,
  TError,
  { data: RevenueHandoverRequest },
  TContext
> => {
  const mutationKey = ['postRevenueHandovers']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postRevenueHandovers>>,
    { data: RevenueHandoverRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postRevenueHandovers(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostRevenueHandoversMutationResult = NonNullable<
  Awaited<ReturnType<typeof postRevenueHandovers>>
>
export type PostRevenueHandoversMutationBody = RevenueHandoverRequest
export type PostRevenueHandoversMutationError = unknown

/**
 * @summary Record a shift's cash handover
 */
export const usePostRevenueHandovers = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postRevenueHandovers>>,
      TError,
      { data: RevenueHandoverRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postRevenueHandovers>>,
  TError,
  { data: RevenueHandoverRequest },
  TContext
> => {
  return useMutation(getPostRevenueHandoversMutationOptions(options), queryClient)
}
export const getPostRevenueHandoversHandledUrl = () => {
  return `/api/v1/revenue-handovers/handled`
}

/**
 * @summary Mark every listed handover nobody has marked yet
 */
export const postRevenueHandoversHandled = async (
  revenueHandoverHandledBatchRequest: RevenueHandoverHandledBatchRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<RevenueHandoverHandledBatch> => {
  return customFetch<RevenueHandoverHandledBatch>(getPostRevenueHandoversHandledUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(revenueHandoverHandledBatchRequest),
  })
}

export const getPostRevenueHandoversHandledMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postRevenueHandoversHandled>>,
    TError,
    { data: RevenueHandoverHandledBatchRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postRevenueHandoversHandled>>,
  TError,
  { data: RevenueHandoverHandledBatchRequest },
  TContext
> => {
  const mutationKey = ['postRevenueHandoversHandled']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postRevenueHandoversHandled>>,
    { data: RevenueHandoverHandledBatchRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postRevenueHandoversHandled(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostRevenueHandoversHandledMutationResult = NonNullable<
  Awaited<ReturnType<typeof postRevenueHandoversHandled>>
>
export type PostRevenueHandoversHandledMutationBody = RevenueHandoverHandledBatchRequest
export type PostRevenueHandoversHandledMutationError = unknown

/**
 * @summary Mark every listed handover nobody has marked yet
 */
export const usePostRevenueHandoversHandled = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postRevenueHandoversHandled>>,
      TError,
      { data: RevenueHandoverHandledBatchRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postRevenueHandoversHandled>>,
  TError,
  { data: RevenueHandoverHandledBatchRequest },
  TContext
> => {
  return useMutation(getPostRevenueHandoversHandledMutationOptions(options), queryClient)
}
export const getPostPaymentsPaymentIdRefundUrl = (paymentId: number) => {
  return `/api/v1/payments/${paymentId}/refund`
}

/**
 * @summary Reverse a payment through the gateway
 */
export const postPaymentsPaymentIdRefund = async (
  paymentId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaymentRefunded> => {
  return customFetch<PaymentRefunded>(getPostPaymentsPaymentIdRefundUrl(paymentId), {
    ...options,
    method: 'POST',
  })
}

export const getPostPaymentsPaymentIdRefundMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPaymentsPaymentIdRefund>>,
    TError,
    { paymentId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPaymentsPaymentIdRefund>>,
  TError,
  { paymentId: number },
  TContext
> => {
  const mutationKey = ['postPaymentsPaymentIdRefund']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPaymentsPaymentIdRefund>>,
    { paymentId: number }
  > = (props) => {
    const { paymentId } = props ?? {}

    return postPaymentsPaymentIdRefund(paymentId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostPaymentsPaymentIdRefundMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPaymentsPaymentIdRefund>>
>

export type PostPaymentsPaymentIdRefundMutationError = unknown

/**
 * @summary Reverse a payment through the gateway
 */
export const usePostPaymentsPaymentIdRefund = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postPaymentsPaymentIdRefund>>,
      TError,
      { paymentId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postPaymentsPaymentIdRefund>>,
  TError,
  { paymentId: number },
  TContext
> => {
  return useMutation(getPostPaymentsPaymentIdRefundMutationOptions(options), queryClient)
}
export const getPostPaymentsSettleStaleUrl = () => {
  return `/api/v1/payments/settle-stale`
}

/**
 * @summary Ask the gateway about this franchise's stale card payments, now
 */
export const postPaymentsSettleStale = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<Swept> => {
  return customFetch<Swept>(getPostPaymentsSettleStaleUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostPaymentsSettleStaleMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPaymentsSettleStale>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPaymentsSettleStale>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postPaymentsSettleStale']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPaymentsSettleStale>>,
    void
  > = () => {
    return postPaymentsSettleStale(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostPaymentsSettleStaleMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPaymentsSettleStale>>
>

export type PostPaymentsSettleStaleMutationError = unknown

/**
 * @summary Ask the gateway about this franchise's stale card payments, now
 */
export const usePostPaymentsSettleStale = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postPaymentsSettleStale>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postPaymentsSettleStale>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostPaymentsSettleStaleMutationOptions(options), queryClient)
}
export const getPostPaymentsInitiateUrl = () => {
  return `/api/v1/payments/initiate`
}

/**
 * @summary Create a payment session for an order
 */
export const postPaymentsInitiate = async (
  initiatePaymentRequest: InitiatePaymentRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<Initiated> => {
  return customFetch<Initiated>(getPostPaymentsInitiateUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(initiatePaymentRequest),
  })
}

export const getPostPaymentsInitiateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPaymentsInitiate>>,
    TError,
    { data: InitiatePaymentRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPaymentsInitiate>>,
  TError,
  { data: InitiatePaymentRequest },
  TContext
> => {
  const mutationKey = ['postPaymentsInitiate']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPaymentsInitiate>>,
    { data: InitiatePaymentRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postPaymentsInitiate(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostPaymentsInitiateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPaymentsInitiate>>
>
export type PostPaymentsInitiateMutationBody = InitiatePaymentRequest
export type PostPaymentsInitiateMutationError = unknown

/**
 * @summary Create a payment session for an order
 */
export const usePostPaymentsInitiate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postPaymentsInitiate>>,
      TError,
      { data: InitiatePaymentRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postPaymentsInitiate>>,
  TError,
  { data: InitiatePaymentRequest },
  TContext
> => {
  return useMutation(getPostPaymentsInitiateMutationOptions(options), queryClient)
}
export const getPostApiPaymentsCallbackUrl = () => {
  return `/api/payments/callback`
}

/**
 * @summary The gateway's payment notification
 */
export const postApiPaymentsCallback = async (
  postApiPaymentsCallbackBody?: PostApiPaymentsCallbackBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaymentCallbackAcknowledged> => {
  return customFetch<PaymentCallbackAcknowledged>(getPostApiPaymentsCallbackUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postApiPaymentsCallbackBody),
  })
}

export const getPostApiPaymentsCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiPaymentsCallback>>,
    TError,
    { data?: PostApiPaymentsCallbackBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiPaymentsCallback>>,
  TError,
  { data?: PostApiPaymentsCallbackBody },
  TContext
> => {
  const mutationKey = ['postApiPaymentsCallback']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiPaymentsCallback>>,
    { data?: PostApiPaymentsCallbackBody }
  > = (props) => {
    const { data } = props ?? {}

    return postApiPaymentsCallback(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostApiPaymentsCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiPaymentsCallback>>
>
export type PostApiPaymentsCallbackMutationBody = PostApiPaymentsCallbackBody | undefined
export type PostApiPaymentsCallbackMutationError = unknown

/**
 * @summary The gateway's payment notification
 */
export const usePostApiPaymentsCallback = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiPaymentsCallback>>,
      TError,
      { data?: PostApiPaymentsCallbackBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiPaymentsCallback>>,
  TError,
  { data?: PostApiPaymentsCallbackBody },
  TContext
> => {
  return useMutation(getPostApiPaymentsCallbackMutationOptions(options), queryClient)
}
export const getPostPaymentsCallbackUrl = () => {
  return `/api/v1/payments/callback`
}

/**
 * @summary The gateway's payment notification
 */
export const postPaymentsCallback = async (
  postPaymentsCallbackBody?: PostPaymentsCallbackBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaymentCallbackAcknowledged> => {
  return customFetch<PaymentCallbackAcknowledged>(getPostPaymentsCallbackUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postPaymentsCallbackBody),
  })
}

export const getPostPaymentsCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPaymentsCallback>>,
    TError,
    { data?: PostPaymentsCallbackBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPaymentsCallback>>,
  TError,
  { data?: PostPaymentsCallbackBody },
  TContext
> => {
  const mutationKey = ['postPaymentsCallback']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPaymentsCallback>>,
    { data?: PostPaymentsCallbackBody }
  > = (props) => {
    const { data } = props ?? {}

    return postPaymentsCallback(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostPaymentsCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPaymentsCallback>>
>
export type PostPaymentsCallbackMutationBody = PostPaymentsCallbackBody | undefined
export type PostPaymentsCallbackMutationError = unknown

/**
 * @summary The gateway's payment notification
 */
export const usePostPaymentsCallback = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postPaymentsCallback>>,
      TError,
      { data?: PostPaymentsCallbackBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postPaymentsCallback>>,
  TError,
  { data?: PostPaymentsCallbackBody },
  TContext
> => {
  return useMutation(getPostPaymentsCallbackMutationOptions(options), queryClient)
}
export const getPostOrdersOrderIdQrPaymentConfirmUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/qr-payment-confirm`
}

/**
 * @summary The driver's own confirmation that the transfer was made
 */
export const postOrdersOrderIdQrPaymentConfirm = async (
  orderId: number,
  qrPaymentConfirmRequest: QrPaymentConfirmRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<QrPaymentConfirmed> => {
  return customFetch<QrPaymentConfirmed>(getPostOrdersOrderIdQrPaymentConfirmUrl(orderId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(qrPaymentConfirmRequest),
  })
}

export const getPostOrdersOrderIdQrPaymentConfirmMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrdersOrderIdQrPaymentConfirm>>,
    TError,
    { orderId: number; data: QrPaymentConfirmRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrdersOrderIdQrPaymentConfirm>>,
  TError,
  { orderId: number; data: QrPaymentConfirmRequest },
  TContext
> => {
  const mutationKey = ['postOrdersOrderIdQrPaymentConfirm']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrdersOrderIdQrPaymentConfirm>>,
    { orderId: number; data: QrPaymentConfirmRequest }
  > = (props) => {
    const { orderId, data } = props ?? {}

    return postOrdersOrderIdQrPaymentConfirm(orderId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOrdersOrderIdQrPaymentConfirmMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrdersOrderIdQrPaymentConfirm>>
>
export type PostOrdersOrderIdQrPaymentConfirmMutationBody = QrPaymentConfirmRequest
export type PostOrdersOrderIdQrPaymentConfirmMutationError = unknown

/**
 * @summary The driver's own confirmation that the transfer was made
 */
export const usePostOrdersOrderIdQrPaymentConfirm = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrdersOrderIdQrPaymentConfirm>>,
      TError,
      { orderId: number; data: QrPaymentConfirmRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrdersOrderIdQrPaymentConfirm>>,
  TError,
  { orderId: number; data: QrPaymentConfirmRequest },
  TContext
> => {
  return useMutation(getPostOrdersOrderIdQrPaymentConfirmMutationOptions(options), queryClient)
}
export const getPostInvoicesInvoiceIdWithdrawFromBatchUrl = (invoiceId: number) => {
  return `/api/v1/invoices/${invoiceId}/withdraw-from-batch`
}

/**
 * Marks every queued payment attempt on the invoice as `withdrawn`, so it may enter a batch again. **Only for a batch nobody uploaded** - this software cannot tell that from one that was, so withdrawing an uploaded invoice pays the supplier twice (§10A.20). The attempt is marked rather than deleted: the log is the only record the first file existed. Idempotent - nothing queued withdraws 0.
 * @summary Withdraw an invoice from a SEPA batch that was never uploaded
 */
export const postInvoicesInvoiceIdWithdrawFromBatch = async (
  invoiceId: number,
  withdrawRequest: WithdrawRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostInvoicesInvoiceIdWithdrawFromBatch200> => {
  return customFetch<PostInvoicesInvoiceIdWithdrawFromBatch200>(
    getPostInvoicesInvoiceIdWithdrawFromBatchUrl(invoiceId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(withdrawRequest),
    },
  )
}

export const getPostInvoicesInvoiceIdWithdrawFromBatchMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postInvoicesInvoiceIdWithdrawFromBatch>>,
    TError,
    { invoiceId: number; data: WithdrawRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdWithdrawFromBatch>>,
  TError,
  { invoiceId: number; data: WithdrawRequest },
  TContext
> => {
  const mutationKey = ['postInvoicesInvoiceIdWithdrawFromBatch']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postInvoicesInvoiceIdWithdrawFromBatch>>,
    { invoiceId: number; data: WithdrawRequest }
  > = (props) => {
    const { invoiceId, data } = props ?? {}

    return postInvoicesInvoiceIdWithdrawFromBatch(invoiceId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostInvoicesInvoiceIdWithdrawFromBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdWithdrawFromBatch>>
>
export type PostInvoicesInvoiceIdWithdrawFromBatchMutationBody = WithdrawRequest
export type PostInvoicesInvoiceIdWithdrawFromBatchMutationError = unknown

/**
 * @summary Withdraw an invoice from a SEPA batch that was never uploaded
 */
export const usePostInvoicesInvoiceIdWithdrawFromBatch = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postInvoicesInvoiceIdWithdrawFromBatch>>,
      TError,
      { invoiceId: number; data: WithdrawRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdWithdrawFromBatch>>,
  TError,
  { invoiceId: number; data: WithdrawRequest },
  TContext
> => {
  return useMutation(getPostInvoicesInvoiceIdWithdrawFromBatchMutationOptions(options), queryClient)
}
export const getPostInvoicesInvoiceIdScheduleAutoPayUrl = (invoiceId: number) => {
  return `/api/v1/invoices/${invoiceId}/schedule-auto-pay`
}

/**
 * @summary Schedule an invoice for automatic payment, or cancel it
 */
export const postInvoicesInvoiceIdScheduleAutoPay = async (
  invoiceId: number,
  scheduleAutoPayRequest: ScheduleAutoPayRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getPostInvoicesInvoiceIdScheduleAutoPayUrl(invoiceId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scheduleAutoPayRequest),
  })
}

export const getPostInvoicesInvoiceIdScheduleAutoPayMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postInvoicesInvoiceIdScheduleAutoPay>>,
    TError,
    { invoiceId: number; data: ScheduleAutoPayRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdScheduleAutoPay>>,
  TError,
  { invoiceId: number; data: ScheduleAutoPayRequest },
  TContext
> => {
  const mutationKey = ['postInvoicesInvoiceIdScheduleAutoPay']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postInvoicesInvoiceIdScheduleAutoPay>>,
    { invoiceId: number; data: ScheduleAutoPayRequest }
  > = (props) => {
    const { invoiceId, data } = props ?? {}

    return postInvoicesInvoiceIdScheduleAutoPay(invoiceId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostInvoicesInvoiceIdScheduleAutoPayMutationResult = NonNullable<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdScheduleAutoPay>>
>
export type PostInvoicesInvoiceIdScheduleAutoPayMutationBody = ScheduleAutoPayRequest
export type PostInvoicesInvoiceIdScheduleAutoPayMutationError = unknown

/**
 * @summary Schedule an invoice for automatic payment, or cancel it
 */
export const usePostInvoicesInvoiceIdScheduleAutoPay = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postInvoicesInvoiceIdScheduleAutoPay>>,
      TError,
      { invoiceId: number; data: ScheduleAutoPayRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdScheduleAutoPay>>,
  TError,
  { invoiceId: number; data: ScheduleAutoPayRequest },
  TContext
> => {
  return useMutation(getPostInvoicesInvoiceIdScheduleAutoPayMutationOptions(options), queryClient)
}
export const getPostInvoicesSepaBatchUrl = () => {
  return `/api/v1/invoices/sepa-batch`
}

/**
 * @summary Build a SEPA batch file for upload to the bank's own portal
 */
export const postInvoicesSepaBatch = async (
  sepaBatchRequest: SepaBatchRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  return customFetch<string>(getPostInvoicesSepaBatchUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sepaBatchRequest),
  })
}

export const getPostInvoicesSepaBatchMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postInvoicesSepaBatch>>,
    TError,
    { data: SepaBatchRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postInvoicesSepaBatch>>,
  TError,
  { data: SepaBatchRequest },
  TContext
> => {
  const mutationKey = ['postInvoicesSepaBatch']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postInvoicesSepaBatch>>,
    { data: SepaBatchRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postInvoicesSepaBatch(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostInvoicesSepaBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postInvoicesSepaBatch>>
>
export type PostInvoicesSepaBatchMutationBody = SepaBatchRequest
export type PostInvoicesSepaBatchMutationError = unknown

/**
 * @summary Build a SEPA batch file for upload to the bank's own portal
 */
export const usePostInvoicesSepaBatch = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postInvoicesSepaBatch>>,
      TError,
      { data: SepaBatchRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postInvoicesSepaBatch>>,
  TError,
  { data: SepaBatchRequest },
  TContext
> => {
  return useMutation(getPostInvoicesSepaBatchMutationOptions(options), queryClient)
}
export const getGetTatrabankaSettingsUrl = () => {
  return `/api/v1/tatrabanka/settings`
}

/**
 * @summary The bank connection, with the secret redacted
 */
export const getTatrabankaSettings = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<Visible> => {
  return customFetch<Visible>(getGetTatrabankaSettingsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetTatrabankaSettingsQueryKey = () => {
  return [`/api/v1/tatrabanka/settings`] as const
}

export const getGetTatrabankaSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTatrabankaSettings>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTatrabankaSettings>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetTatrabankaSettingsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTatrabankaSettings>>> = ({ signal }) =>
    getTatrabankaSettings({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTatrabankaSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTatrabankaSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTatrabankaSettings>>
>
export type GetTatrabankaSettingsQueryError = unknown

export function useGetTatrabankaSettings<
  TData = Awaited<ReturnType<typeof getTatrabankaSettings>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTatrabankaSettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTatrabankaSettings>>,
          TError,
          Awaited<ReturnType<typeof getTatrabankaSettings>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTatrabankaSettings<
  TData = Awaited<ReturnType<typeof getTatrabankaSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTatrabankaSettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTatrabankaSettings>>,
          TError,
          Awaited<ReturnType<typeof getTatrabankaSettings>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTatrabankaSettings<
  TData = Awaited<ReturnType<typeof getTatrabankaSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTatrabankaSettings>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The bank connection, with the secret redacted
 */

export function useGetTatrabankaSettings<
  TData = Awaited<ReturnType<typeof getTatrabankaSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTatrabankaSettings>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTatrabankaSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPatchTatrabankaSettingsUrl = () => {
  return `/api/v1/tatrabanka/settings`
}

/**
 * @summary Change the bank connection
 */
export const patchTatrabankaSettings = async (
  tatrabankaSettingsRequest: TatrabankaSettingsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getPatchTatrabankaSettingsUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(tatrabankaSettingsRequest),
  })
}

export const getPatchTatrabankaSettingsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchTatrabankaSettings>>,
    TError,
    { data: TatrabankaSettingsRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchTatrabankaSettings>>,
  TError,
  { data: TatrabankaSettingsRequest },
  TContext
> => {
  const mutationKey = ['patchTatrabankaSettings']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchTatrabankaSettings>>,
    { data: TatrabankaSettingsRequest }
  > = (props) => {
    const { data } = props ?? {}

    return patchTatrabankaSettings(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchTatrabankaSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchTatrabankaSettings>>
>
export type PatchTatrabankaSettingsMutationBody = TatrabankaSettingsRequest
export type PatchTatrabankaSettingsMutationError = unknown

/**
 * @summary Change the bank connection
 */
export const usePatchTatrabankaSettings = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchTatrabankaSettings>>,
      TError,
      { data: TatrabankaSettingsRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchTatrabankaSettings>>,
  TError,
  { data: TatrabankaSettingsRequest },
  TContext
> => {
  return useMutation(getPatchTatrabankaSettingsMutationOptions(options), queryClient)
}
export const getGetSettingsQrPaymentUrl = () => {
  return `/api/v1/settings/qr-payment`
}

/**
 * @summary The QR payment configuration
 */
export const getSettingsQrPayment = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<QrPaymentSettings> => {
  return customFetch<QrPaymentSettings>(getGetSettingsQrPaymentUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsQrPaymentQueryKey = () => {
  return [`/api/v1/settings/qr-payment`] as const
}

export const getGetSettingsQrPaymentQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsQrPayment>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPayment>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsQrPaymentQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsQrPayment>>> = ({ signal }) =>
    getSettingsQrPayment({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsQrPayment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsQrPaymentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsQrPayment>>
>
export type GetSettingsQrPaymentQueryError = unknown

export function useGetSettingsQrPayment<
  TData = Awaited<ReturnType<typeof getSettingsQrPayment>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPayment>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsQrPayment>>,
          TError,
          Awaited<ReturnType<typeof getSettingsQrPayment>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsQrPayment<
  TData = Awaited<ReturnType<typeof getSettingsQrPayment>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPayment>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsQrPayment>>,
          TError,
          Awaited<ReturnType<typeof getSettingsQrPayment>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsQrPayment<
  TData = Awaited<ReturnType<typeof getSettingsQrPayment>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPayment>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The QR payment configuration
 */

export function useGetSettingsQrPayment<
  TData = Awaited<ReturnType<typeof getSettingsQrPayment>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPayment>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsQrPaymentQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPatchSettingsQrPaymentUrl = () => {
  return `/api/v1/settings/qr-payment`
}

/**
 * @summary Change the QR payment configuration
 */
export const patchSettingsQrPayment = async (
  qrPaymentSettingsRequest: QrPaymentSettingsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<QrPaymentSettings> => {
  return customFetch<QrPaymentSettings>(getPatchSettingsQrPaymentUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(qrPaymentSettingsRequest),
  })
}

export const getPatchSettingsQrPaymentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSettingsQrPayment>>,
    TError,
    { data: QrPaymentSettingsRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSettingsQrPayment>>,
  TError,
  { data: QrPaymentSettingsRequest },
  TContext
> => {
  const mutationKey = ['patchSettingsQrPayment']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSettingsQrPayment>>,
    { data: QrPaymentSettingsRequest }
  > = (props) => {
    const { data } = props ?? {}

    return patchSettingsQrPayment(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchSettingsQrPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSettingsQrPayment>>
>
export type PatchSettingsQrPaymentMutationBody = QrPaymentSettingsRequest
export type PatchSettingsQrPaymentMutationError = unknown

/**
 * @summary Change the QR payment configuration
 */
export const usePatchSettingsQrPayment = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSettingsQrPayment>>,
      TError,
      { data: QrPaymentSettingsRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSettingsQrPayment>>,
  TError,
  { data: QrPaymentSettingsRequest },
  TContext
> => {
  return useMutation(getPatchSettingsQrPaymentMutationOptions(options), queryClient)
}
export const getGetSettingsQrPaymentTbConnectUrl = () => {
  return `/api/v1/settings/qr-payment/tb-connect`
}

/**
 * @summary Start connecting the bank account
 */
export const getSettingsQrPaymentTbConnect = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<TatraBankaConnect> => {
  return customFetch<TatraBankaConnect>(getGetSettingsQrPaymentTbConnectUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsQrPaymentTbConnectQueryKey = () => {
  return [`/api/v1/settings/qr-payment/tb-connect`] as const
}

export const getGetSettingsQrPaymentTbConnectQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsQrPaymentTbConnect>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPaymentTbConnect>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsQrPaymentTbConnectQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsQrPaymentTbConnect>>> = ({
    signal,
  }) => getSettingsQrPaymentTbConnect({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsQrPaymentTbConnect>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsQrPaymentTbConnectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsQrPaymentTbConnect>>
>
export type GetSettingsQrPaymentTbConnectQueryError = unknown

export function useGetSettingsQrPaymentTbConnect<
  TData = Awaited<ReturnType<typeof getSettingsQrPaymentTbConnect>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPaymentTbConnect>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsQrPaymentTbConnect>>,
          TError,
          Awaited<ReturnType<typeof getSettingsQrPaymentTbConnect>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsQrPaymentTbConnect<
  TData = Awaited<ReturnType<typeof getSettingsQrPaymentTbConnect>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPaymentTbConnect>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsQrPaymentTbConnect>>,
          TError,
          Awaited<ReturnType<typeof getSettingsQrPaymentTbConnect>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsQrPaymentTbConnect<
  TData = Awaited<ReturnType<typeof getSettingsQrPaymentTbConnect>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPaymentTbConnect>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Start connecting the bank account
 */

export function useGetSettingsQrPaymentTbConnect<
  TData = Awaited<ReturnType<typeof getSettingsQrPaymentTbConnect>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPaymentTbConnect>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsQrPaymentTbConnectQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetApiSettingsQrPaymentTbCallbackUrl = (
  params?: GetApiSettingsQrPaymentTbCallbackParams,
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/settings/qr-payment/tb-callback?${stringifiedParams}`
    : `/api/settings/qr-payment/tb-callback`
}

/**
 * @summary The bank's consent redirect
 */
export const getApiSettingsQrPaymentTbCallback = async (
  params?: GetApiSettingsQrPaymentTbCallbackParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<TatraBankaConsentCallback> => {
  return customFetch<TatraBankaConsentCallback>(getGetApiSettingsQrPaymentTbCallbackUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetApiSettingsQrPaymentTbCallbackQueryKey = (
  params?: GetApiSettingsQrPaymentTbCallbackParams,
) => {
  return [`/api/settings/qr-payment/tb-callback`, ...(params ? [params] : [])] as const
}

export const getGetApiSettingsQrPaymentTbCallbackQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSettingsQrPaymentTbCallback>>,
  TError = unknown,
>(
  params?: GetApiSettingsQrPaymentTbCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsQrPaymentTbCallback>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetApiSettingsQrPaymentTbCallbackQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiSettingsQrPaymentTbCallback>>> = ({
    signal,
  }) => getApiSettingsQrPaymentTbCallback(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiSettingsQrPaymentTbCallback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSettingsQrPaymentTbCallbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiSettingsQrPaymentTbCallback>>
>
export type GetApiSettingsQrPaymentTbCallbackQueryError = unknown

export function useGetApiSettingsQrPaymentTbCallback<
  TData = Awaited<ReturnType<typeof getApiSettingsQrPaymentTbCallback>>,
  TError = unknown,
>(
  params: undefined | GetApiSettingsQrPaymentTbCallbackParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsQrPaymentTbCallback>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSettingsQrPaymentTbCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiSettingsQrPaymentTbCallback>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSettingsQrPaymentTbCallback<
  TData = Awaited<ReturnType<typeof getApiSettingsQrPaymentTbCallback>>,
  TError = unknown,
>(
  params?: GetApiSettingsQrPaymentTbCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsQrPaymentTbCallback>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiSettingsQrPaymentTbCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiSettingsQrPaymentTbCallback>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiSettingsQrPaymentTbCallback<
  TData = Awaited<ReturnType<typeof getApiSettingsQrPaymentTbCallback>>,
  TError = unknown,
>(
  params?: GetApiSettingsQrPaymentTbCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsQrPaymentTbCallback>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The bank's consent redirect
 */

export function useGetApiSettingsQrPaymentTbCallback<
  TData = Awaited<ReturnType<typeof getApiSettingsQrPaymentTbCallback>>,
  TError = unknown,
>(
  params?: GetApiSettingsQrPaymentTbCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiSettingsQrPaymentTbCallback>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiSettingsQrPaymentTbCallbackQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSettingsQrPaymentTbCallbackUrl = (
  params?: GetSettingsQrPaymentTbCallbackParams,
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/settings/qr-payment/tb-callback?${stringifiedParams}`
    : `/api/v1/settings/qr-payment/tb-callback`
}

/**
 * @summary The bank's consent redirect
 */
export const getSettingsQrPaymentTbCallback = async (
  params?: GetSettingsQrPaymentTbCallbackParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<TatraBankaConsentCallback> => {
  return customFetch<TatraBankaConsentCallback>(getGetSettingsQrPaymentTbCallbackUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsQrPaymentTbCallbackQueryKey = (
  params?: GetSettingsQrPaymentTbCallbackParams,
) => {
  return [`/api/v1/settings/qr-payment/tb-callback`, ...(params ? [params] : [])] as const
}

export const getGetSettingsQrPaymentTbCallbackQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsQrPaymentTbCallback>>,
  TError = unknown,
>(
  params?: GetSettingsQrPaymentTbCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPaymentTbCallback>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsQrPaymentTbCallbackQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsQrPaymentTbCallback>>> = ({
    signal,
  }) => getSettingsQrPaymentTbCallback(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsQrPaymentTbCallback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsQrPaymentTbCallbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsQrPaymentTbCallback>>
>
export type GetSettingsQrPaymentTbCallbackQueryError = unknown

export function useGetSettingsQrPaymentTbCallback<
  TData = Awaited<ReturnType<typeof getSettingsQrPaymentTbCallback>>,
  TError = unknown,
>(
  params: undefined | GetSettingsQrPaymentTbCallbackParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPaymentTbCallback>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsQrPaymentTbCallback>>,
          TError,
          Awaited<ReturnType<typeof getSettingsQrPaymentTbCallback>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsQrPaymentTbCallback<
  TData = Awaited<ReturnType<typeof getSettingsQrPaymentTbCallback>>,
  TError = unknown,
>(
  params?: GetSettingsQrPaymentTbCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPaymentTbCallback>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsQrPaymentTbCallback>>,
          TError,
          Awaited<ReturnType<typeof getSettingsQrPaymentTbCallback>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsQrPaymentTbCallback<
  TData = Awaited<ReturnType<typeof getSettingsQrPaymentTbCallback>>,
  TError = unknown,
>(
  params?: GetSettingsQrPaymentTbCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPaymentTbCallback>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The bank's consent redirect
 */

export function useGetSettingsQrPaymentTbCallback<
  TData = Awaited<ReturnType<typeof getSettingsQrPaymentTbCallback>>,
  TError = unknown,
>(
  params?: GetSettingsQrPaymentTbCallbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPaymentTbCallback>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsQrPaymentTbCallbackQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSettingsQrPaymentActiveUrl = () => {
  return `/api/v1/settings/qr-payment/active`
}

/**
 * @summary Whether QR payment is available
 */
export const getSettingsQrPaymentActive = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<QrPaymentAvailability> => {
  return customFetch<QrPaymentAvailability>(getGetSettingsQrPaymentActiveUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsQrPaymentActiveQueryKey = () => {
  return [`/api/v1/settings/qr-payment/active`] as const
}

export const getGetSettingsQrPaymentActiveQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsQrPaymentActive>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPaymentActive>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsQrPaymentActiveQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsQrPaymentActive>>> = ({
    signal,
  }) => getSettingsQrPaymentActive({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsQrPaymentActive>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsQrPaymentActiveQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsQrPaymentActive>>
>
export type GetSettingsQrPaymentActiveQueryError = unknown

export function useGetSettingsQrPaymentActive<
  TData = Awaited<ReturnType<typeof getSettingsQrPaymentActive>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPaymentActive>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsQrPaymentActive>>,
          TError,
          Awaited<ReturnType<typeof getSettingsQrPaymentActive>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsQrPaymentActive<
  TData = Awaited<ReturnType<typeof getSettingsQrPaymentActive>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPaymentActive>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsQrPaymentActive>>,
          TError,
          Awaited<ReturnType<typeof getSettingsQrPaymentActive>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsQrPaymentActive<
  TData = Awaited<ReturnType<typeof getSettingsQrPaymentActive>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPaymentActive>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whether QR payment is available
 */

export function useGetSettingsQrPaymentActive<
  TData = Awaited<ReturnType<typeof getSettingsQrPaymentActive>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsQrPaymentActive>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsQrPaymentActiveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetSettingsPaymentsPublicUrl = () => {
  return `/api/v1/settings/payments/public`
}

/**
 * @summary Which payment methods the checkout offers
 */
export const getSettingsPaymentsPublic = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<PublicPaymentSettings> => {
  return customFetch<PublicPaymentSettings>(getGetSettingsPaymentsPublicUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsPaymentsPublicQueryKey = () => {
  return [`/api/v1/settings/payments/public`] as const
}

export const getGetSettingsPaymentsPublicQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsPaymentsPublic>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettingsPaymentsPublic>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsPaymentsPublicQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsPaymentsPublic>>> = ({
    signal,
  }) => getSettingsPaymentsPublic({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsPaymentsPublic>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsPaymentsPublicQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsPaymentsPublic>>
>
export type GetSettingsPaymentsPublicQueryError = unknown

export function useGetSettingsPaymentsPublic<
  TData = Awaited<ReturnType<typeof getSettingsPaymentsPublic>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPaymentsPublic>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsPaymentsPublic>>,
          TError,
          Awaited<ReturnType<typeof getSettingsPaymentsPublic>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsPaymentsPublic<
  TData = Awaited<ReturnType<typeof getSettingsPaymentsPublic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPaymentsPublic>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsPaymentsPublic>>,
          TError,
          Awaited<ReturnType<typeof getSettingsPaymentsPublic>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsPaymentsPublic<
  TData = Awaited<ReturnType<typeof getSettingsPaymentsPublic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPaymentsPublic>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Which payment methods the checkout offers
 */

export function useGetSettingsPaymentsPublic<
  TData = Awaited<ReturnType<typeof getSettingsPaymentsPublic>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsPaymentsPublic>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsPaymentsPublicQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetPaymentsUrl = (params?: GetPaymentsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/api/v1/payments?${stringifiedParams}` : `/api/v1/payments`
}

/**
 * A bare array, as v1 has always answered. `GET /payments/count` reports how many there are in total under the same filters - this endpoint defaults to 50 rows, so a caller cannot otherwise tell a full page from the whole archive.
 *
 * `search` matches the order number or the payment reference.
 *
 * `method` is `card_pay` or `qr_pay` - §10A.126. Omitted means every method, including the rows whose method the gateway never named.
 * @summary The payments, newest first
 */
export const getPayments = async (
  params?: GetPaymentsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<OnlinePayment[]> => {
  return customFetch<OnlinePayment[]>(getGetPaymentsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetPaymentsQueryKey = (params?: GetPaymentsParams) => {
  return [`/api/v1/payments`, ...(params ? [params] : [])] as const
}

export const getGetPaymentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPayments>>,
  TError = unknown,
>(
  params?: GetPaymentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayments>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPaymentsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayments>>> = ({ signal }) =>
    getPayments(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPayments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof getPayments>>>
export type GetPaymentsQueryError = unknown

export function useGetPayments<TData = Awaited<ReturnType<typeof getPayments>>, TError = unknown>(
  params: undefined | GetPaymentsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayments>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayments>>,
          TError,
          Awaited<ReturnType<typeof getPayments>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayments<TData = Awaited<ReturnType<typeof getPayments>>, TError = unknown>(
  params?: GetPaymentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayments>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayments>>,
          TError,
          Awaited<ReturnType<typeof getPayments>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayments<TData = Awaited<ReturnType<typeof getPayments>>, TError = unknown>(
  params?: GetPaymentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayments>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The payments, newest first
 */

export function useGetPayments<TData = Awaited<ReturnType<typeof getPayments>>, TError = unknown>(
  params?: GetPaymentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayments>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPaymentsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetPaymentsPaymentIdUrl = (paymentId: number) => {
  return `/api/v1/payments/${paymentId}`
}

/**
 * @summary One payment
 */
export const getPaymentsPaymentId = async (
  paymentId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<OnlinePayment> => {
  return customFetch<OnlinePayment>(getGetPaymentsPaymentIdUrl(paymentId), {
    ...options,
    method: 'GET',
  })
}

export const getGetPaymentsPaymentIdQueryKey = (paymentId: number) => {
  return [`/api/v1/payments/${paymentId}`] as const
}

export const getGetPaymentsPaymentIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentsPaymentId>>,
  TError = unknown,
>(
  paymentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsPaymentId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPaymentsPaymentIdQueryKey(paymentId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentsPaymentId>>> = ({ signal }) =>
    getPaymentsPaymentId(paymentId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: paymentId !== null && paymentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getPaymentsPaymentId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetPaymentsPaymentIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentsPaymentId>>
>
export type GetPaymentsPaymentIdQueryError = unknown

export function useGetPaymentsPaymentId<
  TData = Awaited<ReturnType<typeof getPaymentsPaymentId>>,
  TError = unknown,
>(
  paymentId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsPaymentId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsPaymentId>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsPaymentId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsPaymentId<
  TData = Awaited<ReturnType<typeof getPaymentsPaymentId>>,
  TError = unknown,
>(
  paymentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsPaymentId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsPaymentId>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsPaymentId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsPaymentId<
  TData = Awaited<ReturnType<typeof getPaymentsPaymentId>>,
  TError = unknown,
>(
  paymentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsPaymentId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One payment
 */

export function useGetPaymentsPaymentId<
  TData = Awaited<ReturnType<typeof getPaymentsPaymentId>>,
  TError = unknown,
>(
  paymentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsPaymentId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPaymentsPaymentIdQueryOptions(paymentId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetPaymentsUnreconciledUrl = (params?: GetPaymentsUnreconciledParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/payments/unreconciled?${stringifiedParams}`
    : `/api/v1/payments/unreconciled`
}

/**
 * Orders whose method is `card_online`, whose payment never settled, and for which no payment session exists at all - so they appear in neither `GET /payments` nor the stale sweep. The checkout writes the order before it creates the session, and these are the ones where only the first call happened. Nothing is resolved here: each is an order somebody has to decide about.
 * @summary Card orders that never reached the bank
 */
export const getPaymentsUnreconciled = async (
  params?: GetPaymentsUnreconciledParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<UnreconciledCardOrders> => {
  return customFetch<UnreconciledCardOrders>(getGetPaymentsUnreconciledUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetPaymentsUnreconciledQueryKey = (params?: GetPaymentsUnreconciledParams) => {
  return [`/api/v1/payments/unreconciled`, ...(params ? [params] : [])] as const
}

export const getGetPaymentsUnreconciledQueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentsUnreconciled>>,
  TError = unknown,
>(
  params?: GetPaymentsUnreconciledParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsUnreconciled>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPaymentsUnreconciledQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentsUnreconciled>>> = ({
    signal,
  }) => getPaymentsUnreconciled(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPaymentsUnreconciled>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentsUnreconciledQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentsUnreconciled>>
>
export type GetPaymentsUnreconciledQueryError = unknown

export function useGetPaymentsUnreconciled<
  TData = Awaited<ReturnType<typeof getPaymentsUnreconciled>>,
  TError = unknown,
>(
  params: undefined | GetPaymentsUnreconciledParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsUnreconciled>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsUnreconciled>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsUnreconciled>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsUnreconciled<
  TData = Awaited<ReturnType<typeof getPaymentsUnreconciled>>,
  TError = unknown,
>(
  params?: GetPaymentsUnreconciledParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsUnreconciled>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsUnreconciled>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsUnreconciled>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsUnreconciled<
  TData = Awaited<ReturnType<typeof getPaymentsUnreconciled>>,
  TError = unknown,
>(
  params?: GetPaymentsUnreconciledParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsUnreconciled>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Card orders that never reached the bank
 */

export function useGetPaymentsUnreconciled<
  TData = Awaited<ReturnType<typeof getPaymentsUnreconciled>>,
  TError = unknown,
>(
  params?: GetPaymentsUnreconciledParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsUnreconciled>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPaymentsUnreconciledQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetPaymentsTestConnectionUrl = () => {
  return `/api/v1/payments/test-connection`
}

/**
 * @summary Whether the gateway answers, and in which mode
 */
export const getPaymentsTestConnection = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<PaymentConnectionTest> => {
  return customFetch<PaymentConnectionTest>(getGetPaymentsTestConnectionUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetPaymentsTestConnectionQueryKey = () => {
  return [`/api/v1/payments/test-connection`] as const
}

export const getGetPaymentsTestConnectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentsTestConnection>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getPaymentsTestConnection>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPaymentsTestConnectionQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentsTestConnection>>> = ({
    signal,
  }) => getPaymentsTestConnection({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPaymentsTestConnection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentsTestConnectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentsTestConnection>>
>
export type GetPaymentsTestConnectionQueryError = unknown

export function useGetPaymentsTestConnection<
  TData = Awaited<ReturnType<typeof getPaymentsTestConnection>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsTestConnection>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsTestConnection>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsTestConnection>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsTestConnection<
  TData = Awaited<ReturnType<typeof getPaymentsTestConnection>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsTestConnection>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsTestConnection>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsTestConnection>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsTestConnection<
  TData = Awaited<ReturnType<typeof getPaymentsTestConnection>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsTestConnection>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whether the gateway answers, and in which mode
 */

export function useGetPaymentsTestConnection<
  TData = Awaited<ReturnType<typeof getPaymentsTestConnection>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsTestConnection>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPaymentsTestConnectionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetPaymentsReturnUrl = (params?: GetPaymentsReturnParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/payments/return?${stringifiedParams}`
    : `/api/v1/payments/return`
}

/**
 * @summary The customer's return from the bank's page
 */
export const getPaymentsReturn = async (
  params?: GetPaymentsReturnParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getGetPaymentsReturnUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetPaymentsReturnQueryKey = (params?: GetPaymentsReturnParams) => {
  return [`/api/v1/payments/return`, ...(params ? [params] : [])] as const
}

export const getGetPaymentsReturnQueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentsReturn>>,
  TError = unknown,
>(
  params?: GetPaymentsReturnParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsReturn>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPaymentsReturnQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentsReturn>>> = ({ signal }) =>
    getPaymentsReturn(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPaymentsReturn>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentsReturnQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentsReturn>>
>
export type GetPaymentsReturnQueryError = unknown

export function useGetPaymentsReturn<
  TData = Awaited<ReturnType<typeof getPaymentsReturn>>,
  TError = unknown,
>(
  params: undefined | GetPaymentsReturnParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsReturn>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsReturn>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsReturn>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsReturn<
  TData = Awaited<ReturnType<typeof getPaymentsReturn>>,
  TError = unknown,
>(
  params?: GetPaymentsReturnParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsReturn>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsReturn>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsReturn>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsReturn<
  TData = Awaited<ReturnType<typeof getPaymentsReturn>>,
  TError = unknown,
>(
  params?: GetPaymentsReturnParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsReturn>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The customer's return from the bank's page
 */

export function useGetPaymentsReturn<
  TData = Awaited<ReturnType<typeof getPaymentsReturn>>,
  TError = unknown,
>(
  params?: GetPaymentsReturnParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsReturn>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPaymentsReturnQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetApiPaymentsReturnUrl = (params?: GetApiPaymentsReturnParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/payments/return?${stringifiedParams}`
    : `/api/payments/return`
}

/**
 * @summary The customer's return from the bank's page
 */
export const getApiPaymentsReturn = async (
  params?: GetApiPaymentsReturnParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getGetApiPaymentsReturnUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetApiPaymentsReturnQueryKey = (params?: GetApiPaymentsReturnParams) => {
  return [`/api/payments/return`, ...(params ? [params] : [])] as const
}

export const getGetApiPaymentsReturnQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiPaymentsReturn>>,
  TError = unknown,
>(
  params?: GetApiPaymentsReturnParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiPaymentsReturn>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetApiPaymentsReturnQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPaymentsReturn>>> = ({ signal }) =>
    getApiPaymentsReturn(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiPaymentsReturn>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiPaymentsReturnQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiPaymentsReturn>>
>
export type GetApiPaymentsReturnQueryError = unknown

export function useGetApiPaymentsReturn<
  TData = Awaited<ReturnType<typeof getApiPaymentsReturn>>,
  TError = unknown,
>(
  params: undefined | GetApiPaymentsReturnParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiPaymentsReturn>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPaymentsReturn>>,
          TError,
          Awaited<ReturnType<typeof getApiPaymentsReturn>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPaymentsReturn<
  TData = Awaited<ReturnType<typeof getApiPaymentsReturn>>,
  TError = unknown,
>(
  params?: GetApiPaymentsReturnParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiPaymentsReturn>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPaymentsReturn>>,
          TError,
          Awaited<ReturnType<typeof getApiPaymentsReturn>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiPaymentsReturn<
  TData = Awaited<ReturnType<typeof getApiPaymentsReturn>>,
  TError = unknown,
>(
  params?: GetApiPaymentsReturnParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiPaymentsReturn>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The customer's return from the bank's page
 */

export function useGetApiPaymentsReturn<
  TData = Awaited<ReturnType<typeof getApiPaymentsReturn>>,
  TError = unknown,
>(
  params?: GetApiPaymentsReturnParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiPaymentsReturn>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiPaymentsReturnQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetPaymentsGpwebpayQrTokenUrl = (token: string) => {
  return `/api/v1/payments/gpwebpay/qr/${token}`
}

/**
 * @summary The door's GP webpay code, redirecting to the payment page
 */
export const getPaymentsGpwebpayQrToken = async (
  token: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getGetPaymentsGpwebpayQrTokenUrl(token), {
    ...options,
    method: 'GET',
  })
}

export const getGetPaymentsGpwebpayQrTokenQueryKey = (token: string) => {
  return [`/api/v1/payments/gpwebpay/qr/${token}`] as const
}

export const getGetPaymentsGpwebpayQrTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentsGpwebpayQrToken>>,
  TError = unknown,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsGpwebpayQrToken>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPaymentsGpwebpayQrTokenQueryKey(token)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentsGpwebpayQrToken>>> = ({
    signal,
  }) => getPaymentsGpwebpayQrToken(token, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: token !== null && token !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getPaymentsGpwebpayQrToken>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetPaymentsGpwebpayQrTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentsGpwebpayQrToken>>
>
export type GetPaymentsGpwebpayQrTokenQueryError = unknown

export function useGetPaymentsGpwebpayQrToken<
  TData = Awaited<ReturnType<typeof getPaymentsGpwebpayQrToken>>,
  TError = unknown,
>(
  token: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsGpwebpayQrToken>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsGpwebpayQrToken>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsGpwebpayQrToken>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsGpwebpayQrToken<
  TData = Awaited<ReturnType<typeof getPaymentsGpwebpayQrToken>>,
  TError = unknown,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsGpwebpayQrToken>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsGpwebpayQrToken>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsGpwebpayQrToken>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsGpwebpayQrToken<
  TData = Awaited<ReturnType<typeof getPaymentsGpwebpayQrToken>>,
  TError = unknown,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsGpwebpayQrToken>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The door's GP webpay code, redirecting to the payment page
 */

export function useGetPaymentsGpwebpayQrToken<
  TData = Awaited<ReturnType<typeof getPaymentsGpwebpayQrToken>>,
  TError = unknown,
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsGpwebpayQrToken>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPaymentsGpwebpayQrTokenQueryOptions(token, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetPaymentsCountUrl = (params?: GetPaymentsCountParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/payments/count?${stringifiedParams}`
    : `/api/v1/payments/count`
}

/**
 * Takes the same `status`, `search` and `method` as the list, so the two cannot disagree about what they describe. `paidTotal` counts only rows in `paid` - summing every row would add the abandoned and the refused to the money received.
 *
 * `cardPayCount` and `qrPayCount` come off the same scan as the per-status counts, so the archive's chips do not each cost a request - §10A.126.
 *
 * `paidCardPayTotal` and `paidQrPayTotal` split `paidTotal` the way the chips split the rows: by what the payment was opened as, so a door QR paid by card is QR Pay - §10A.419.
 * @summary How many payments match, and what was actually paid
 */
export const getPaymentsCount = async (
  params?: GetPaymentsCountParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaymentCounts> => {
  return customFetch<PaymentCounts>(getGetPaymentsCountUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetPaymentsCountQueryKey = (params?: GetPaymentsCountParams) => {
  return [`/api/v1/payments/count`, ...(params ? [params] : [])] as const
}

export const getGetPaymentsCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentsCount>>,
  TError = unknown,
>(
  params?: GetPaymentsCountParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsCount>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPaymentsCountQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentsCount>>> = ({ signal }) =>
    getPaymentsCount(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPaymentsCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentsCountQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentsCount>>>
export type GetPaymentsCountQueryError = unknown

export function useGetPaymentsCount<
  TData = Awaited<ReturnType<typeof getPaymentsCount>>,
  TError = unknown,
>(
  params: undefined | GetPaymentsCountParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsCount>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsCount>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsCount>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsCount<
  TData = Awaited<ReturnType<typeof getPaymentsCount>>,
  TError = unknown,
>(
  params?: GetPaymentsCountParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsCount>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsCount>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsCount>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsCount<
  TData = Awaited<ReturnType<typeof getPaymentsCount>>,
  TError = unknown,
>(
  params?: GetPaymentsCountParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsCount>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary How many payments match, and what was actually paid
 */

export function useGetPaymentsCount<
  TData = Awaited<ReturnType<typeof getPaymentsCount>>,
  TError = unknown,
>(
  params?: GetPaymentsCountParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsCount>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPaymentsCountQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetPaymentsByDriverUrl = (params?: GetPaymentsByDriverParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/payments/by-driver?${stringifiedParams}`
    : `/api/v1/payments/by-driver`
}

/**
 * Per driving account, every order it owns in the window - the handover's own set - with what the gateway's sessions and the payment-method trail say about it, and a summary over all of them. Deliveries nobody owns are a group of their own.
 *
 * `dateFrom` and `dateTo` are Bratislava business days, `YYYY-MM-DD`. Both omitted is today and one omitted is that one day. A malformed or reversed range answers 400 `DRIVER_PAYMENTS_RANGE_INVALID`, one wider than 31 days 400 `DRIVER_PAYMENTS_RANGE_TOO_WIDE`.
 *
 * Only orders with something to check are listed; the summary counts every owned order. Money is in cents.
 * @summary Each driver's orders, checked against the payment gateway
 */
export const getPaymentsByDriver = async (
  params?: GetPaymentsByDriverParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DriverPaymentsReport> => {
  return customFetch<DriverPaymentsReport>(getGetPaymentsByDriverUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetPaymentsByDriverQueryKey = (params?: GetPaymentsByDriverParams) => {
  return [`/api/v1/payments/by-driver`, ...(params ? [params] : [])] as const
}

export const getGetPaymentsByDriverQueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentsByDriver>>,
  TError = unknown,
>(
  params?: GetPaymentsByDriverParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsByDriver>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetPaymentsByDriverQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentsByDriver>>> = ({ signal }) =>
    getPaymentsByDriver(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPaymentsByDriver>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentsByDriverQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentsByDriver>>
>
export type GetPaymentsByDriverQueryError = unknown

export function useGetPaymentsByDriver<
  TData = Awaited<ReturnType<typeof getPaymentsByDriver>>,
  TError = unknown,
>(
  params: undefined | GetPaymentsByDriverParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsByDriver>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsByDriver>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsByDriver>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsByDriver<
  TData = Awaited<ReturnType<typeof getPaymentsByDriver>>,
  TError = unknown,
>(
  params?: GetPaymentsByDriverParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPaymentsByDriver>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsByDriver>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsByDriver>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsByDriver<
  TData = Awaited<ReturnType<typeof getPaymentsByDriver>>,
  TError = unknown,
>(
  params?: GetPaymentsByDriverParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsByDriver>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Each driver's orders, checked against the payment gateway
 */

export function useGetPaymentsByDriver<
  TData = Awaited<ReturnType<typeof getPaymentsByDriver>>,
  TError = unknown,
>(
  params?: GetPaymentsByDriverParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsByDriver>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPaymentsByDriverQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetOrdersOrderIdQrPaymentStatusUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/qr-payment-status`
}

/**
 * @summary Whether the transfer for this order has landed
 */
export const getOrdersOrderIdQrPaymentStatus = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<QrPaymentStatus> => {
  return customFetch<QrPaymentStatus>(getGetOrdersOrderIdQrPaymentStatusUrl(orderId), {
    ...options,
    method: 'GET',
  })
}

export const getGetOrdersOrderIdQrPaymentStatusQueryKey = (orderId: number) => {
  return [`/api/v1/orders/${orderId}/qr-payment-status`] as const
}

export const getGetOrdersOrderIdQrPaymentStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentStatus>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentStatus>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrdersOrderIdQrPaymentStatusQueryKey(orderId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentStatus>>> = ({
    signal,
  }) => getOrdersOrderIdQrPaymentStatus(orderId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: orderId !== null && orderId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrdersOrderIdQrPaymentStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentStatus>>
>
export type GetOrdersOrderIdQrPaymentStatusQueryError = unknown

export function useGetOrdersOrderIdQrPaymentStatus<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentStatus>>,
  TError = unknown,
>(
  orderId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentStatus>>,
          TError,
          Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentStatus>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersOrderIdQrPaymentStatus<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentStatus>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentStatus>>,
          TError,
          Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentStatus>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersOrderIdQrPaymentStatus<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentStatus>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentStatus>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whether the transfer for this order has landed
 */

export function useGetOrdersOrderIdQrPaymentStatus<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentStatus>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentStatus>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrdersOrderIdQrPaymentStatusQueryOptions(orderId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetOrdersOrderIdQrPaymentDataUrl = (orderId: number) => {
  return `/api/v1/orders/${orderId}/qr-payment-data`
}

/**
 * @summary The QR code to show for one order
 */
export const getOrdersOrderIdQrPaymentData = async (
  orderId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<QrPaymentData> => {
  return customFetch<QrPaymentData>(getGetOrdersOrderIdQrPaymentDataUrl(orderId), {
    ...options,
    method: 'GET',
  })
}

export const getGetOrdersOrderIdQrPaymentDataQueryKey = (orderId: number) => {
  return [`/api/v1/orders/${orderId}/qr-payment-data`] as const
}

export const getGetOrdersOrderIdQrPaymentDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentData>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentData>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOrdersOrderIdQrPaymentDataQueryKey(orderId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentData>>> = ({
    signal,
  }) => getOrdersOrderIdQrPaymentData(orderId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: orderId !== null && orderId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentData>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetOrdersOrderIdQrPaymentDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentData>>
>
export type GetOrdersOrderIdQrPaymentDataQueryError = unknown

export function useGetOrdersOrderIdQrPaymentData<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentData>>,
  TError = unknown,
>(
  orderId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentData>>,
          TError,
          Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentData>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersOrderIdQrPaymentData<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentData>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentData>>,
          TError,
          Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentData>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrdersOrderIdQrPaymentData<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentData>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentData>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The QR code to show for one order
 */

export function useGetOrdersOrderIdQrPaymentData<
  TData = Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentData>>,
  TError = unknown,
>(
  orderId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrdersOrderIdQrPaymentData>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrdersOrderIdQrPaymentDataQueryOptions(orderId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetInvoicesInvoiceIdPaymentAttemptsUrl = (invoiceId: number) => {
  return `/api/v1/invoices/${invoiceId}/payment-attempts`
}

/**
 * @summary Every payment attempt against one invoice
 */
export const getInvoicesInvoiceIdPaymentAttempts = async (
  invoiceId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<Attempt[]> => {
  return customFetch<Attempt[]>(getGetInvoicesInvoiceIdPaymentAttemptsUrl(invoiceId), {
    ...options,
    method: 'GET',
  })
}

export const getGetInvoicesInvoiceIdPaymentAttemptsQueryKey = (invoiceId: number) => {
  return [`/api/v1/invoices/${invoiceId}/payment-attempts`] as const
}

export const getGetInvoicesInvoiceIdPaymentAttemptsQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdPaymentAttempts>>,
  TError = unknown,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInvoicesInvoiceIdPaymentAttempts>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoicesInvoiceIdPaymentAttemptsQueryKey(invoiceId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoicesInvoiceIdPaymentAttempts>>> = ({
    signal,
  }) => getInvoicesInvoiceIdPaymentAttempts(invoiceId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: invoiceId !== null && invoiceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvoicesInvoiceIdPaymentAttempts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicesInvoiceIdPaymentAttemptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvoicesInvoiceIdPaymentAttempts>>
>
export type GetInvoicesInvoiceIdPaymentAttemptsQueryError = unknown

export function useGetInvoicesInvoiceIdPaymentAttempts<
  TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdPaymentAttempts>>,
  TError = unknown,
>(
  invoiceId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInvoicesInvoiceIdPaymentAttempts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesInvoiceIdPaymentAttempts>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesInvoiceIdPaymentAttempts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesInvoiceIdPaymentAttempts<
  TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdPaymentAttempts>>,
  TError = unknown,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInvoicesInvoiceIdPaymentAttempts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesInvoiceIdPaymentAttempts>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesInvoiceIdPaymentAttempts>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesInvoiceIdPaymentAttempts<
  TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdPaymentAttempts>>,
  TError = unknown,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInvoicesInvoiceIdPaymentAttempts>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every payment attempt against one invoice
 */

export function useGetInvoicesInvoiceIdPaymentAttempts<
  TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdPaymentAttempts>>,
  TError = unknown,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getInvoicesInvoiceIdPaymentAttempts>>,
        TError,
        TData
      >
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetInvoicesInvoiceIdPaymentAttemptsQueryOptions(invoiceId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetInvoicesSepaBatchPreviewUrl = (params: GetInvoicesSepaBatchPreviewParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ['ids']

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v))
      })
      return
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/invoices/sepa-batch/preview?${stringifiedParams}`
    : `/api/v1/invoices/sepa-batch/preview`
}

/**
 * The same decision the POST makes, from the same code, without building the file or recording a payment attempt. `skipped` names each invoice and why - already paid, cancelled, missing an IBAN, or already sitting in a batch somebody downloaded (§10A.19).
 * @summary What a SEPA batch would contain, and what it would leave out
 */
export const getInvoicesSepaBatchPreview = async (
  params: GetInvoicesSepaBatchPreviewParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Plan> => {
  return customFetch<Plan>(getGetInvoicesSepaBatchPreviewUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetInvoicesSepaBatchPreviewQueryKey = (
  params?: GetInvoicesSepaBatchPreviewParams,
) => {
  return [`/api/v1/invoices/sepa-batch/preview`, ...(params ? [params] : [])] as const
}

export const getGetInvoicesSepaBatchPreviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvoicesSepaBatchPreview>>,
  TError = unknown,
>(
  params: GetInvoicesSepaBatchPreviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoicesSepaBatchPreview>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetInvoicesSepaBatchPreviewQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoicesSepaBatchPreview>>> = ({
    signal,
  }) => getInvoicesSepaBatchPreview(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvoicesSepaBatchPreview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicesSepaBatchPreviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvoicesSepaBatchPreview>>
>
export type GetInvoicesSepaBatchPreviewQueryError = unknown

export function useGetInvoicesSepaBatchPreview<
  TData = Awaited<ReturnType<typeof getInvoicesSepaBatchPreview>>,
  TError = unknown,
>(
  params: GetInvoicesSepaBatchPreviewParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoicesSepaBatchPreview>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesSepaBatchPreview>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesSepaBatchPreview>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesSepaBatchPreview<
  TData = Awaited<ReturnType<typeof getInvoicesSepaBatchPreview>>,
  TError = unknown,
>(
  params: GetInvoicesSepaBatchPreviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoicesSepaBatchPreview>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesSepaBatchPreview>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesSepaBatchPreview>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesSepaBatchPreview<
  TData = Awaited<ReturnType<typeof getInvoicesSepaBatchPreview>>,
  TError = unknown,
>(
  params: GetInvoicesSepaBatchPreviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoicesSepaBatchPreview>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What a SEPA batch would contain, and what it would leave out
 */

export function useGetInvoicesSepaBatchPreview<
  TData = Awaited<ReturnType<typeof getInvoicesSepaBatchPreview>>,
  TError = unknown,
>(
  params: GetInvoicesSepaBatchPreviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoicesSepaBatchPreview>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetInvoicesSepaBatchPreviewQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
